import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { UUID } from '@/types';

type State = {
  lastVisitedDashboardId: Maybe<UUID>;
  dashboardIdToAppliedFiltersRefreshIdMap: Record<UUID, UUID>;
};

const initialState: State = {
  lastVisitedDashboardId: null,
  dashboardIdToAppliedFiltersRefreshIdMap: {},
};

export const dashboardsSlice = createSlice({
  name: 'dashboardsSlice',
  initialState,
  reducers: {
    setLastVisitedDashboardId: (
      state,
      action: PayloadAction<State['lastVisitedDashboardId']>,
    ) => {
      state.lastVisitedDashboardId = action.payload;
    },
    resetDashboardIdToAppliedFiltersRefreshIdMap: (state) => {
      state.dashboardIdToAppliedFiltersRefreshIdMap = {};
    },
  },
  extraReducers: {
    DASHBOARD_REFRESHED_LEGACY: (state, action) => {
      const { dashboardId, refreshId, hasAppliedFilters } = action.payload;

      if (hasAppliedFilters) {
        state.dashboardIdToAppliedFiltersRefreshIdMap = {
          [dashboardId]: refreshId,
        };
      } else {
        state.dashboardIdToAppliedFiltersRefreshIdMap = {};
      }
    },
    MODAL_INTERACTION: (state, action) => {
      const { modalType, props } = action.payload;

      if (
        modalType === 'dashboards_view' &&
        props.section === 'applied-filters' &&
        props.filters.length === 0
      ) {
        state.dashboardIdToAppliedFiltersRefreshIdMap = {};
      }
    },
  },
});

export const selectLastVisitedDashboardId = (state: RootState) =>
  state.dashboardsSlice.lastVisitedDashboardId;

export const selectDashboardIdToAppliedFiltersRefreshIdMap = (
  state: RootState,
) => state.dashboardsSlice.dashboardIdToAppliedFiltersRefreshIdMap;

export const {
  setLastVisitedDashboardId,
  resetDashboardIdToAppliedFiltersRefreshIdMap,
} = dashboardsSlice.actions;
